import { Box, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, InputLabel, MenuItem, Pagination, Paper, Tooltip, Select, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography, IconButton, Link } from "@mui/material"
import Dropdown from "../../reusable_components/components/Dropdown"
import MUIButton from "../../reusable_components/components/MUIButton"
import React, { useContext, useEffect, useState } from "react"
import { useClientHiringListMutation } from "../../redux/reports/reports.api"
import { useEventDropDownQuery, useGetClientDropdownQuery } from "../../redux/jobpostings/jobpostings.api"
import dayjs from 'dayjs'
import { useNavigate } from "react-router-dom"
import { SnackbarContext } from "../../reusable_components/components/Snackbar"
import { TableLoader } from "../../reusable_components/components/TableLoader"
import MUICancelButton from "../../reusable_components/components/MuiCancelButton"
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import CloseIcon from '@mui/icons-material/Close';
import FilterListIcon from '@mui/icons-material/FilterList';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DownloadIcon from "../../assets/Icons/DownloadIcon"
import CalendarIcon from "../../assets/Icons/CalendarIcon"
import SearchIconLg from "../../assets/Icons/SearchIcon"
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker"
import * as XLSX from "xlsx";
import DoneIcon from "@mui/icons-material/Done";
import ExcelJS from 'exceljs/dist/exceljs.min.js'; // browser build
import { saveAs } from 'file-saver';
import ClearIcon from "@mui/icons-material/Clear";
import './reports.css'

const ClientHiringReport = () => {

    const commonFilter = JSON.parse(localStorage.getItem("commonsearchfilter"));
    const navigate = useNavigate()
    const [page, setPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [totalCount, setTotalCount] = useState(0)
    const [selectedClient, setSelectedClient] = useState(commonFilter?.clientHiringReport?.clientId || '')
    const [selectedClientId, setSelectedClientId] = useState(commonFilter?.clientHiringReport?.clientName || "")
    const [selectedEvent, setSelectedEvent] = useState([])
    const [allClientHiringReport, setAllClientHiringReport] = useState([]);
    const [clientHiringReport, setClientHiringReport] = useState([]);
    const [showTableLoader, setShowTableLoader] = useState(false)
    const [filteredEventDatas, setFilteredEventDatas] = useState([])
    const [selectedFromDate, setSelectedFromDate] = useState(commonFilter?.clientHiringReport?.fromDate
        ? dayjs(commonFilter?.clientHiringReport?.fromDate)
        : null)
    const [selectedToDate, setSelectedToDate] = useState(commonFilter?.clientHiringReport?.toDate
        ? dayjs(commonFilter?.clientHiringReport?.toDate)
        : null)
    const [triggerApi, setTriggerApi] = useState(false)
    const [open, setOpen] = useState(false)
    const [showClearFilter, setShowClearFilter] = useState(false)
    const [downloadProgress, setDownloadProgress] = useState(null);
    const [dashBoardDisabled, setDashBoardDisabled] = useState(false)
    const [selectedStatus, setSelectedStatus] = useState(commonFilter?.clientHiringReport?.positionStatus || 'Active');
    const [openByStatus, setOpenByStatus] = useState(false);

    const handleOpen = () => {
        if (chips.length === 0) {
            setSelectedClient("")
            setFilteredEventDatas([])
            setSelectedEvent([])
            setSelectedFromDate(null)
            setSelectedToDate(null)
            setChips([])
            setOpen(true)
        } else {
            setOpen(true)
        }
    }

    const handleClose = () => {
        setOpen(false)

    }

    const handlePageChange = (event, value) => {
        setPage(value);

        const startIndex = (value - 1) * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;

        setClientHiringReport(allClientHiringReport.slice(startIndex, endIndex));
    };

    const [getClientHiringData] = useClientHiringListMutation()
    const { data: clientDropdown } = useGetClientDropdownQuery()
    const { data: eventsDropdown } = useEventDropDownQuery()
    const { Snackbar } = useContext(SnackbarContext)

    const handleFromDateChange = (value) => {
        setSelectedFromDate(value)

        if (selectedToDate && value >= selectedToDate) {
            setSelectedToDate(null)
        }
        const currentFilter =
            JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

        const updatedFilter = {
            ...currentFilter,
            clientHiringReport: {
                ...currentFilter.clientHiringReport,
                fromDate: value,
            },
        };

        localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
    }

    const handleToDateChange = (value) => {
        setSelectedToDate(value)
        const currentFilter =
            JSON.parse(localStorage.getItem("commonsearchfilter")) || {};

        const updatedFilter = {
            ...currentFilter,
            clientHiringReport: {
                ...currentFilter.clientHiringReport,
                toDate: value,
            },
        };

        localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
    }

    const getNextDay = (fromDate) => {
        if (!fromDate) {
            return null
        }
        return dayjs(fromDate)?.add(1, 'day')
    }

    const handleStatusChange = (e) => {
        const value = e.target.value;
        setSelectedStatus(value);

        const currentFilter =
            JSON.parse(localStorage.getItem("commonsearchfilter")) || {};
        const updatedFilter = {
            ...currentFilter,
            clientHiringReport: {
                ...currentFilter.clientHiringReport,
                positionStatus: value || "",
            },
        };
        localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
    };

    const handleClientNameChange = (value) => {
        setSelectedClient(value)
        const name = clientDropdown?.response?.clientList?.find((item) => item?.clientId === value)
        const clientName = name?.clientName
        setSelectedClientId(name?.clientName)
        const currentFilter =
            JSON.parse(localStorage.getItem("commonsearchfilter")) || {};
        const updatedFilter = {
            ...currentFilter,
            clientHiringReport: {
                ...currentFilter.clientHiringReport,
                clientName: clientName,
                clientId: value,
            },
        };
        localStorage.setItem("commonsearchfilter", JSON.stringify(updatedFilter));
    }

    const [chips, setChips] = useState([])

    const letsFilterDatas = () => {
        const updatedChips = [
            selectedClientId && {
                label: selectedClientId,
                onDelete: () => {
                    setSelectedClient("");
                    setFilteredEventDatas([]);
                    setSelectedEvent([]);
                    setTriggerApi(true);
                    setChips(prevChips => prevChips.filter(chip => chip.label !== selectedClientId));
                }
            },
            selectedStatus && {
                label: selectedStatus,
                onDelete: () => {
                    setSelectedStatus("");
                    setFilteredEventDatas([]);
                    setSelectedEvent([]);
                    setTriggerApi(true);
                    setChips(prevChips => prevChips.filter(chip => chip.label !== selectedStatus));
                }
            },
            ...filteredEventDatas?.map(eventItem => ({
                label: eventItem?.event,
                onDelete: () => {
                    setSelectedEvent(prev => prev.filter(id => id !== eventItem?.eventTypeId));
                    setFilteredEventDatas(prev => prev.filter(name => name?.event !== eventItem?.event));
                    setTriggerApi(true);
                    setChips(prevChips => prevChips.filter(chip => chip.label !== eventItem?.event));
                }
            })),
            selectedFromDate && {
                label: dayjs(selectedFromDate)?.format('DD-MM-YYYY'),
                onDelete: () => {
                    setSelectedFromDate(null);
                    setSelectedToDate(null);
                    setTriggerApi(true);
                    setChips(prevChips => prevChips.filter(chip => chip.label !== dayjs(selectedFromDate)?.format('DD-MM-YYYY')));
                }
            },
            selectedToDate && {
                label: dayjs(selectedToDate)?.format('DD-MM-YYYY'),
                onDelete: () => {
                    setSelectedToDate(null);
                    setTriggerApi(true);
                    setChips(prevChips => prevChips.filter(chip => chip.label !== dayjs(selectedToDate)?.format('DD-MM-YYYY')));
                }
            }
        ]
            .filter(Boolean);
        setChips(updatedChips);
        setTriggerApi(true);
        setShowClearFilter(true);
    };



    useEffect(() => {
        const eventNames = eventsDropdown?.response?.filter((item) => (
            selectedEvent?.includes?.(item?.eventTypeId)
        ))
        setFilteredEventDatas(eventNames || [])
    }, [selectedEvent])

    const getTableDatas = async () => {
        try {
            const params = {
                clientId: selectedClient,
                positionStatus: selectedStatus,
                page: 0,
                size: 10,
                fromDate: selectedFromDate ? dayjs(selectedFromDate).format('YYYY-MM-DD') : "",
                toDate: selectedToDate ? dayjs(selectedToDate).format('YYYY-MM-DD') : ""
            };

            setShowTableLoader(true);
            const response = await getClientHiringData(params).unwrap();
            setShowTableLoader(false);

            const data = response?.clients || [];
            setAllClientHiringReport(data);
            localStorage.setItem("data", data)
            setTotalCount(data.length);
            setClientHiringReport(data.slice(0, rowsPerPage));

        } catch (err) {
            Snackbar('Network error', 'error');
            setShowTableLoader(false);
        }
    };

    useEffect(() => {
        getTableDatas()
    }, [])

    useEffect(() => {
        if (triggerApi) {
            getTableDatas()
            setTriggerApi(false)
            handleClose()
        }
    }, [triggerApi])

    const handleClearFilterChange = () => {
        setSelectedClient("")
        setFilteredEventDatas([])
        setSelectedEvent([])
        setTriggerApi(true)
        setSelectedFromDate(null)
        setSelectedToDate(null)
        setShowClearFilter(false)
        setChips([])
        setSelectedStatus("")
        localStorage.setItem(
            "commonsearchfilter",
            JSON.stringify({ ...commonFilter, clientHiringReport: {} })
        );
    }

    const downloadExcel = async () => {
        if (!allClientHiringReport || !allClientHiringReport.length) {
            Snackbar("No data available to download", "warning");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Hiring Report", {
            views: [{ state: "frozen", ySplit: 2 }]
        });

        // Define header with S.No as first column
        const headers = [
            "S.No",
            "Client",
            "Position",
            "No.of Positions",
            "Offered Count",
            "Joined Count",
            "Offered Candidates",
            "Joined Candidates",
            "Status"
        ];

        worksheet.columns = headers.map(h => ({
            header: h,
            key: h,
            width: h === "S.No" ? 8 : 25
        }));

        // Title rowlog
        worksheet.insertRow(1, ["Client Hiring Summary List"]);
        worksheet.mergeCells("A1:H1");

        const titleRow = worksheet.getRow(1);
        titleRow.height = 28;
        titleRow.getCell(1).font = { bold: true, size: 16 };
        titleRow.getCell(1).alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true
        };

        let currentRow = 3;      // data starts at row 3 (1 = title, 2 = header)
        let serialNumber = 1;    // serial per client

        allClientHiringReport.forEach(item => {
            const jobs = item.positions || [];
            const rowSpan = jobs.length > 0 ? jobs.length : 1;
            const startRow = currentRow;
            const endRow = currentRow + rowSpan - 1;

            if (jobs.length === 0) {
                // Single row when no job
                worksheet.addRow({
                    "S.No": serialNumber,
                    Client: item.clientName,
                    Position: "-",
                    "No.of Positions": "-",
                    "Offered Count": "-",
                    "Joined Count": "-",
                    "Offered Candidates": "-",
                    "Joined Candidates": "-",
                    Status: "-"
                });

                const row = worksheet.getRow(currentRow);
                row.getCell(1).alignment = { horizontal: "center", vertical: "middle", wrapText: true };
                row.getCell(2).alignment = { horizontal: "center", vertical: "middle", wrapText: true };

                currentRow++;
            } else {
                // Add all job rows
                jobs.forEach((job, index) => {
                    worksheet.addRow({
                        "S.No": index === 0 ? serialNumber : "",
                        Client: index === 0 ? item.clientName : "",
                        Position: job.positionName || "-",
                        "No.of Positions": job?.noOfPositions || '',
                        "Offered Count": job.offeredCount || "-",
                        "Joined Count": job.joinedCount || "-",
                        "Offered Candidates":
                            job.candidatesOffered?.map(c => c.candidateName).join(", ") || "-",
                        "Joined Candidates":
                            job.candidatesJoined?.map(c => c.candidateName).join(", ") || "-",
                        Status: job.positionStatus || "-"
                    });

                    currentRow++;
                });

                // Merge S.No and Client cells vertically
                worksheet.mergeCells(`A${startRow}:A${endRow}`);
                worksheet.mergeCells(`B${startRow}:B${endRow}`);

                // Center align merged cells
                const sNoCell = worksheet.getCell(`A${startRow}`);
                sNoCell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };

                const clientCell = worksheet.getCell(`B${startRow}`);
                clientCell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
            }

            serialNumber++;
        });

        const headerRow = worksheet.getRow(2);
        headerRow.height = 24;

        headerRow.eachCell(cell => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12 };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "7F56D9" }
            };
            cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" }
            };
        });

        worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
            if (rowNumber === 1 || rowNumber === 2) return;

            row.eachCell((cell, colNumber) => {
                cell.alignment = {
                    horizontal: colNumber === 1 ? "center" : "left",  // S.No center, rest left
                    vertical: "top",
                    wrapText: true
                };
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };
            });
        });

        // Auto-adjust row heights
        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber === 1 || rowNumber === 2) return;

            let maxHeight = 20;
            row.eachCell(cell => {
                const cellValue = cell.value ? String(cell.value) : "";
                const lineCount = Math.ceil(cellValue.length / 50);
                const estimatedHeight = lineCount * 15 + 5;
                maxHeight = Math.max(maxHeight, estimatedHeight);
            });

            row.height = maxHeight;
        });

        worksheet.columns.forEach(col => {
            let maxLength = (col.header || "").length;
            col.eachCell({ includeEmpty: true }, cell => {
                const value = cell.value ? String(cell.value) : "";
                maxLength = Math.max(maxLength, value.length);
            });
            col.width = Math.min(50, maxLength + 5);
        });

        // Download file
        const buf = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buf], { type: "application/octet-stream" });
        saveAs(blob, `ClientHiringReport${dayjs().format("YYYY-MM-DD")}.xlsx`);
    };

    const statusOptions = [
        {
            id: "Active",
            label: "Active",
        },
        {
            id: "Inactive",
            label: "Inactive",
        },
        {
            id: "Fulfilled",
            label: "Fulfilled",
        },
        {
            id: "Closed",
            label: "Closed",
        },
        {
            id: "Hold by client",
            label: "Hold by client",
        },
        {
            id: "Dropped by 3E",
            label: "Dropped by 3E",
        },
        {
            id: "Pending",
            label: "Pending",
        },
    ];

    const statusStyleMap = {
        "Active": { text: "#067647", border: "#ABEFC6", bg: "#ECFDF3" },
        "Approved": { text: "#067647", border: "#ABEFC6", bg: "#ECFDF3" },
        "Cancelled": { text: "#B42318", border: "#FECDCA", bg: "#FEF3F2" },
        "Rejected": { text: "#B42318", border: "#FECDCA", bg: "#FEF3F2" },
        "Inactive": { text: "#B42318", border: "#FECDCA", bg: "#FEF3F2" },
        "Fulfilled": { text: "#6941C6", border: "#E9D7FE", bg: "#F9F5FF" },
        "Closed": { text: "#414651", border: "#E9EAEB", bg: "#FAFAFA" },
        "Pending": { text: "#414651", border: "#E9EAEB", bg: "#FAFAFA" },
        "Hold by client": { text: "#414651", border: "#E9EAEB", bg: "#FAFAFA" },
        "Dropped by 3E": { text: "#414651", border: "#E9EAEB", bg: "#FAFAFA" },
    };

    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem("commonsearchfilter")) || {};
        const clientHir = stored?.clientHiringReport;

        const hasValue =
            clientHir &&
            Object.values(clientHir).some(
                (value) =>
                    value !== "" && value !== 0 && value !== null && value !== undefined
            );
        if (hasValue) {
            letsFilterDatas()
            getTableDatas()
        } else if (selectedStatus) {
            letsFilterDatas()
            getTableDatas()
        }
    }, []);

    return (
        <Box className='container'>
            <Grid2 item sx={{ display: 'flex', alignItems: 'center', color: '#6941C6', gap: '4px', cursor: 'pointer', width: '40px', marginBottom: '20px' }} onClick={() => navigate(-1)}>
                <ArrowBackIcon sx={{ fontSize: '17px' }} />
                <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Back</Typography>
            </Grid2>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                <Typography className="title">Client Hiring Report </Typography>

                <div style={{ display: 'flex', gap: '30px' }}>
                    {
                        clientHiringReport?.length > 0 && (
                            <Tooltip
                                title={dashBoardDisabled === true && ('Please Wait...')}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            backgroundColor: 'black',
                                            color: 'white',
                                            '& .MuiTooltip-arrow': {
                                                color: 'black',
                                            }
                                        }
                                    }
                                }}
                                arrow
                            >
                                <MUIButton
                                    title={downloadProgress !== null ? `Downloading... ${downloadProgress}%` : 'Download'}
                                    onClick={downloadExcel}
                                    disabled={!allClientHiringReport.length}
                                    startIcon={<DownloadIcon stroke={'white'} />}
                                    sx={{ color: 'white', border: '1px solid #D6BBFB', width: '200px' }}
                                />
                            </Tooltip>
                        )
                    }
                </div>
            </div>
            {/* More Filters */}
            <Grid2 item>
                <Dialog
                    open={open}
                    scroll="paper"
                    maxWidth='md'
                    className="sidePopup"
                >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '18px', fontWeight: 550 }}>
                        Filters
                        <CloseIcon sx={{ color: '#717680', cursor: 'pointer' }} onClick={handleClose} />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Grid2 container sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '100%' }} gap={2}>
                                    <Grid2 item>
                                        <InputLabel className="inputlabels">Client Name</InputLabel>
                                        <Dropdown
                                            placeholder='Select Client'
                                            value={selectedClient || ""}
                                            onChange={handleClientNameChange}
                                            options={clientDropdown?.response?.clientList || []}
                                            valueKey='clientId'
                                            labelKey='clientName'
                                        />
                                    </Grid2>
                                </Grid2>
                                <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '15px' }} gap={2}>
                                    <Grid2 item>
                                        <InputLabel className="inputlabels">From Date</InputLabel>
                                        <MuiDatePicker
                                            value={selectedFromDate}
                                            onChange={handleFromDateChange}
                                            slots={{
                                                openPickerIcon: CalendarIcon
                                            }}
                                            sx={{
                                                "& .MuiInputBase-input": {
                                                    fontSize: '14px'
                                                },
                                                "& .MuiSvgIcon-root": {
                                                    fontSize: '20px'
                                                },
                                                width: '100%'
                                            }}
                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                    placeholder: 'Choose From Date',
                                                    InputProps: {
                                                        sx: { borderRadius: '10px' }
                                                    }
                                                }
                                            }}
                                            format="DD-MM-YYYY"
                                        />
                                    </Grid2>

                                    <Grid2 item>
                                        <InputLabel className="inputlabels">To Date</InputLabel>
                                        <MuiDatePicker
                                            value={selectedToDate}
                                            disabled={selectedFromDate === null}
                                            onChange={handleToDateChange}
                                            sx={{
                                                "& .MuiInputBase-input": {
                                                    fontSize: '14px'
                                                },
                                                "& .MuiSvgIcon-root": {
                                                    fontSize: '20px'
                                                },
                                                width: '100%'
                                            }}
                                            slots={{
                                                openPickerIcon: CalendarIcon
                                            }}
                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                    placeholder: 'Choose To Date',
                                                    InputProps: {
                                                        sx: { borderRadius: '10px' }
                                                    }
                                                }
                                            }}
                                            minDate={getNextDay(selectedFromDate) || null}
                                            maxDate={dayjs()}
                                            format="DD-MM-YYYY"
                                            disableOpenPicker={!selectedFromDate}
                                        />
                                    </Grid2>
                                </Grid2>
                                <Grid2 item sx={{ marginTop: '15px' }}>
                                    <InputLabel className="input"> Status </InputLabel>
                                    <Select
                                        className="dropdown"
                                        displayEmpty
                                        value={selectedStatus || ""}
                                        onChange={handleStatusChange}
                                        IconComponent={KeyboardArrowDownIcon}
                                        open={openByStatus}
                                        onOpen={() => setOpenByStatus(true)}
                                        onClose={() => setOpenByStatus(false)}
                                        renderValue={(selected) =>
                                            !selected ? (
                                                <p className="menuItemsPlaceholder">
                                                    Select By Status
                                                </p>
                                            ) : (
                                                statusOptions?.find(
                                                    (name) => name?.label === selected
                                                )?.label || ""
                                            )
                                        }
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                {" "}
                                                <span className="menuItemsPlaceholder">
                                                    {" "}
                                                    Select By Status{" "}
                                                </span>
                                            </MenuItem>
                                            <Tooltip title={"Close"} arrow>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => {
                                                        setOpenByStatus(false);
                                                    }}
                                                >
                                                    <ClearIcon
                                                        sx={{ fontSize: "18px", color: "#a2a2a2" }}
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                        {statusOptions?.map((option) => (
                                            <MenuItem
                                                className="menuitems"
                                                key={option?.id}
                                                value={option?.label}
                                            >
                                                {option?.label}
                                                {option?.label === selectedStatus && (
                                                    <DoneIcon className="doneIcon" />
                                                )}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid2>
                            </Grid2>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Grid2 item sx={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '20px' }}>

                            <MUICancelButton title='Cancel' onClick={handleClose} sx={{ width: '42%' }} />
                            <MUIButton title='Apply' sx={{ width: '42%' }}
                                onClick={letsFilterDatas}
                            />
                        </Grid2>
                    </DialogActions>
                </Dialog>
            </Grid2>
            <Grid2 container sx={{ marginTop: '15px' }}>
                <Paper sx={{ width: '100%', overflow: 'auto', border: '1px solid #E9EAEB' }} elevation={0}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={100}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div>
                                            {
                                                chips?.map((item, index) => {
                                                    return (
                                                        item?.label && item?.label?.length > 0 && (
                                                            <Chip
                                                                className="Chip"
                                                                key={index}
                                                                label={item?.label}
                                                                size="small"
                                                                variant="outlined"
                                                                onDelete={item?.onDelete}
                                                                deleteIcon={<CloseIcon sx={{ color: '#414651 !important' }} />}
                                                            />
                                                        )
                                                    )
                                                })

                                            }
                                        </div>
                                        <div style={{ display: 'flex', gap: '14px' }}>
                                            <MUICancelButton title='More Filters' onClick={handleOpen} startIcon={<FilterListIcon sx={{ fontSize: '20px !important' }} />} sx={{ color: '#6941C6', borderColor: '#D6BBFB', fontWeight: 600, width: '130px' }} />
                                            {chips?.length > 0 ? (
                                                <MUICancelButton title='Clear Filter' sx={{ width: '100px' }} onClick={handleClearFilterChange} />
                                            ) : ("")
                                            }
                                        </div>
                                    </div>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="tableHeadersCell">Client</TableCell>
                                <TableCell className="tableHeadersCell">Positions</TableCell>
                                <TableCell className="tableHeadersCell">No.of Positions</TableCell>
                                <TableCell className="tableHeadersCell">Offered Count</TableCell>
                                <TableCell className="tableHeadersCell">Joined Count</TableCell>
                                <TableCell className="tableHeadersCell">Offered Candidate</TableCell>
                                <TableCell className="tableHeadersCell">Joined Candidate</TableCell>
                                <TableCell className="tableHeadersCell">Position Status</TableCell>
                            </TableRow>
                        </TableHead>

                        {!showTableLoader ? (
                            clientHiringReport?.length > 0 ? (
                                <TableBody>
                                    {clientHiringReport?.map((item, index) => {
                                        const jobs = item?.positions || [];
                                        const rowSpan = jobs.length > 0 ? jobs.length : 1;

                                        return (
                                            <React.Fragment key={index}>
                                                {jobs.length > 0 ? (
                                                    jobs.map((job, jobIndex) => (
                                                        <TableRow
                                                            key={jobIndex}
                                                            sx={{
                                                                backgroundColor: (index % 2 === 1 ? '#FAFAFA' : 'inherit'),
                                                                // '&:hover': { backgroundColor: '#f1f1f1' },
                                                            }}
                                                        >
                                                            {jobIndex === 0 && (
                                                                <TableCell
                                                                    rowSpan={rowSpan}
                                                                    className="tableBodyCell"
                                                                    style={{
                                                                        fontWeight: 600,
                                                                        fontSize: "12px",
                                                                        color: "#53389E",
                                                                        width: '150px',
                                                                        borderRight: "1px solid #E9EAEB",
                                                                    }}
                                                                >
                                                                    {item.clientName}
                                                                </TableCell>

                                                            )}

                                                            <TableCell className="tableBodyCell">
                                                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyItems: 'center', alignItems: 'center', gap: '2px' }}>
                                                                    {job?.positionName || "-"}
                                                                </Box>

                                                            </TableCell>

                                                            <TableCell className="tableBodyCell">
                                                                {job?.noOfPositions || "-"}
                                                            </TableCell>

                                                            <TableCell className="tableBodyCell">
                                                                {job?.offeredCount || "-"}
                                                            </TableCell>

                                                            <TableCell className="tableBodyCell">
                                                                {job?.joinedCount || "-"}
                                                            </TableCell>

                                                            <TableCell className="tableBodyCell">
                                                                {job.candidatesOffered && job.candidatesOffered.length > 0 ? (
                                                                    job.candidatesOffered.map((offered, index) => (
                                                                        <Tooltip
                                                                            title={`Sourced By: ${offered?.createdByName}`}
                                                                            componentsProps={{
                                                                                tooltip: {
                                                                                    sx: {
                                                                                        backgroundColor: 'black',
                                                                                        color: 'white',
                                                                                        '& .MuiTooltip-arrow': {
                                                                                            color: 'black',
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }}
                                                                        >
                                                                            <Link
                                                                                key={index}
                                                                                sx={{ cursor: "pointer", display: "block" }}
                                                                                onClick={() => navigate(`/candidate-view/${offered?.candidateId}`)}
                                                                            >
                                                                                {offered.candidateName}
                                                                            </Link>
                                                                        </Tooltip>
                                                                    ))
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </TableCell>

                                                            <TableCell className="tableBodyCell">
                                                                {job.candidatesJoined && job.candidatesJoined.length > 0 ? (
                                                                    job.candidatesJoined.map((join, index) => (
                                                                        <Tooltip
                                                                            title={`Sourced By: ${join?.createdByName}`}
                                                                            componentsProps={{
                                                                                tooltip: {
                                                                                    sx: {
                                                                                        backgroundColor: 'black',
                                                                                        color: 'white',
                                                                                        '& .MuiTooltip-arrow': {
                                                                                            color: 'black',
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }}
                                                                        >
                                                                            <Link
                                                                                key={index}
                                                                                sx={{ cursor: "pointer", display: "block" }}
                                                                                onClick={() => navigate(`/candidate-view/${join?.candidateId}`)}
                                                                            >
                                                                                {join.candidateName}
                                                                            </Link>
                                                                        </Tooltip>

                                                                    ))
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </TableCell>


                                                            <TableCell className="tableBodyCell">
                                                                {(() => {
                                                                    const status = job?.positionStatus;
                                                                    if (!status) return "-";

                                                                    const style = statusStyleMap[status] || {
                                                                        text: "#000",
                                                                        border: "#E9EAEB",
                                                                        bg: "#F5F5F5"
                                                                    };

                                                                    return (
                                                                        <Box
                                                                            sx={{
                                                                                display: "inline-flex",
                                                                                alignItems: "center",
                                                                                gap: 1,
                                                                                border: `1px solid ${style.border}`,
                                                                                padding: "2px 10px",
                                                                                background: style.bg,
                                                                                borderRadius: "20px",
                                                                            }}
                                                                        >
                                                                            <Box
                                                                                sx={{
                                                                                    width: 8,
                                                                                    height: 8,
                                                                                    borderRadius: "50%",
                                                                                    background: style.text,
                                                                                }}
                                                                            />
                                                                            <Typography
                                                                                variant="body2"
                                                                                sx={{
                                                                                    fontSize: "12px",
                                                                                    fontWeight: 500,
                                                                                    color: style.text,
                                                                                    textTransform: "capitalize",
                                                                                }}
                                                                            >
                                                                                {status}
                                                                            </Typography>
                                                                        </Box>
                                                                    );
                                                                })()}
                                                            </TableCell>

                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow
                                                        sx={{
                                                            backgroundColor: (index % 2 === 1 ? '#FAFAFA' : 'inherit'),
                                                            '&:hover': { backgroundColor: '#f1f1f1' },
                                                        }}
                                                    >
                                                        <TableCell
                                                            rowSpan={1}
                                                            className="tableBodyCell"
                                                            style={{
                                                                fontWeight: 600,
                                                                fontSize: "12px",
                                                                color: "#53389E",
                                                            }}
                                                        >
                                                            {item.clientName}
                                                        </TableCell>
                                                        <TableCell className="tableBodyCell">-</TableCell>
                                                        <TableCell className="tableBodyCell">-</TableCell>
                                                        <TableCell className="tableBodyCell">-</TableCell>
                                                        <TableCell className="tableBodyCell">-</TableCell>
                                                        <TableCell className="tableBodyCell">-</TableCell>
                                                    </TableRow>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </TableBody>

                            ) : (
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={8}>
                                            <Typography className="emptydatas">No Data Found</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )
                        ) : (
                            <TableRow>
                                <TableCell colSpan={8}>
                                    <Box className='tableloader'>
                                        <TableLoader />
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )}
                        {Math.ceil(totalCount / rowsPerPage) > 1 && (
                            <TableRow>
                                <TableCell colSpan={100}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <MUICancelButton
                                            title='Previous'
                                            startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                            onClick={() => handlePageChange(null, page - 1)}
                                            disabled={page === 1}
                                            sx={{ height: '36px' }}
                                        />

                                        <Pagination
                                            page={page}
                                            onChange={handlePageChange}
                                            count={Math.ceil(totalCount / rowsPerPage)}
                                            shape="rounded"
                                            siblingCount={3}
                                            boundaryCount={3}
                                            hidePrevButton
                                            hideNextButton
                                        />

                                        <MUICancelButton
                                            title='Next'
                                            startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(totalCount / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                            disabled={page === Math.ceil(totalCount / rowsPerPage)}
                                            onClick={() => handlePageChange(null, page + 1)}
                                            sx={{ height: '36px' }}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                        )}
                    </Table>
                </Paper>
            </Grid2>
        </Box>
    )
}

export default ClientHiringReport